const colors = {
  champagnePink: '#d8c6bd',
  isabelline: '#f4efea',
  nickel: '#6b6e65',
  champagnePinkLight: '#eddcd2',
  linen: '#f4eae4',
  lightgrey: '#fafafa',
  black: '#2b2523',
  antiqueBrass: '#cb997e',
  desertSand: '#ddbea9',
  artichoke: '#a5a58d',
  ashGrey: '#b7b7a4',
}

module.exports = colors
